import styled from 'styled-components';

export const InputWrapper = styled.div`
  display: flex;
  gap: 1rem;
  align-items: flex-end;
  flex-wrap: wrap;
  justify-content: flex-start;
  
  & > * {
    flex: 0 0 auto;
  }
  
  .cds--date-picker {
    width: auto;
    min-width: 200px;
  }
  
  .cds--select {
    width: auto;
    min-width: 180px;
  }
`;